const wrappedContractNames: Record<number, string> = {
  1: 'WETH', //mainnet
  5: 'WETH', //goerli
  10: 'WETH', //optimism
  56: 'WBNB', //bnb
  204: 'WBNB', //opbnb
  137: 'WMATIC', //polygon
  1101: 'WETH ', // zkEVM
  324: 'WETH', //weth
  42161: 'WETH', //arbitrum
  42170: 'WETH', //arbitrum nova
  43114: 'WAVAX', //avalance
  59144: 'WETH',
  999: 'WETH', //zoratestnet
  80001: 'WMATIC', //mumbai
  8453: 'WETH', //base
  84531: 'WETH', //base goerli
  84532: 'WETH', //base sepolia
  534353: 'WETH', //scrolltestnet
  534352: 'WETH', //scroll
  7777777: 'WETH', //zora
  11155111: 'WETH', //sepolia
  888888888: 'WETH', //ancient8
  28122024: 'WETH', //ancient8 testnet
  68840142: 'WETH', //frametestnet
  168587773: 'WETH', //blast sepolia
  70700: 'WETH', //apex pop
  81457: 'WETH', //blast
  1235: 'WAURA', //aura evm dev
  1236: 'WAURA', //aura evm dev
  6321: 'WAURA', //aura evm dev
  6322: 'WAURA', //aura evm dev
}
export default wrappedContractNames
